// @flow
import * as types from "./commonActionTypes";

export function setClientId(clientId) {
    return { type: types.SET_CLIENT_ID, clientId};
}

export function setClientInfo(userId, fullName, level) {
    return { type: types.SET_CLIENT_INFO, userId, fullName, level};
}

export function gotLogoutUpdate(fromClientId) {
    return { type: types.GOT_LOGOUT_UPDATE, fromClientId};
}

export function gotLoginUpdate(result, fromClientId) {
    return {type : types.GOT_LOGIN_UPDATE, result, fromClientId};
}

export function gotFWError(errorText, origin) {
    return { type: types.GOT_FIRMWARE_ERROR, errorText, origin};
}

export function gotServerInfo(name, version, id, config) {
    return { type: types.GOT_SERVER_INFO, name, version, id, config };
}
export function getFWInfoSuccess({fwVersion, wsVersion, serialNum, fromClientId, deviceName}) {
    return { type: types.GET_FW_INFO_SUCCESS,
        fwVersion,
        wsVersion,
        serialNum,
        fromClientId,
        deviceName
    };
}

export function getServerStatusSuccess({status, state, lightColor, uptimeSecs, systemTicks, lastError}) {
    return { type: types.GET_SERVERSTATUS_SUCCESS,
        status,
        state,
        lightColor,
        uptimeSecs,
        systemTicks,
        lastError
    };
}

export function attemptServerReconnect() {
    return { type: types.ATTEMPT_DEVICE_RECONNECT};
}

export function getMagInfoSuccess(magInfo) {
    return { type: types.GET_MAGINFO_SUCCESS, magInfo};
}

export function clearMagAndSamples() {
    return { type: types.CLEAR_MAG_AND_SAMPLES};
}

export function updateLightColor(color, flash) {
    return {type: types.GOT_LIGHT_UPDATE, color, flash};
}

export function gotStatsInfo(statsInfo) {
    return {type: types.GET_STATSINFO_SUCCESS, statsInfo}
}

export function gotProfilesList(profiles) {
    return {type: types.GOT_PROFILES_LIST, profiles}
}

export function gotCurrentProfileSet(profileSet) {
    return {type: types.GOT_CURRENT_PROFILESET, profileSet};
}

//#region MAG_TYPES
export function gotMagTypes(magTypes) {
    return { type: types.GOT_MAG_TYPES_LIST, magTypes};
}
//#endregion MAG_TYPES

//#region SAMPLE_TYPES
export function gotSampleTypes(sampleTypes) {
    return { type: types.GOT_SAMPLE_TYPES_LIST, sampleTypes};
}
//#endregion SAMPLE_TYPES

export function gotMarkSectionFull(section, isFull) {
    return {type: types.GOT_MARK_SECTION_FULL, section, isFull};
}

export function setDeviceStatusAndMode(status, mode) {
    return {type: types.SET_DEVICE_STATUS_AND_MODE, status, mode};
}

export function gotNumSyncLogItems(numSyncItems) {
    return {type: types.GOT_NUM_SYNC_ITEMS, numSyncItems};
}
export function gotCurrentRemoteUserInfo(currentUser) {
    return {type: types.GOT_CURRENT_REMOTE_USER_INFO, currentUser:currentUser};
}
